import {Negotiation} from "@/modules/diplomacy/entity";
import {ChildEntity, ManyToOne} from "typeorm";
import {YouthPlayer} from "@/modules/youth/entity/YouthPlayer";

@ChildEntity()
export class YouthPlayerNegotiation extends Negotiation {
  @ManyToOne(() => YouthPlayer, r => r.negotiations)
  declare target: YouthPlayer;
}
